import { GetterTree } from 'vuex'
import { RootState } from '../types'
import State, { ICountry, ICountryState, IIncoTerm } from './types'

export const getters: GetterTree<State, RootState> = {
  countries(state): ICountry[] {
    const { countries } = state
    return countries || []
  },
  countryStates(state): ICountryState[] {
    const { countryStates } = state
    return countryStates || []
  },
  storageLocations(state): string[] {
    const { storageLocations } = state
    return storageLocations || []
  },
  incoTerms(state): IIncoTerm[] {
    const { incoTerms } = state
    return incoTerms || []
  },
}
